import { mockPayouts, Payout } from "../../../../modules/Payouts/utils/mocks";
import { WSService } from "../../../../utils/WSService";

const service = new WSService("/v2/payments/payouts");

export const getPayouts = async (): Promise<Payout[]> => {
  const { data } = await service.get("");
  // const data = new Promise<Payout[]>(resolve => {
  //   setTimeout(() => {
  //     resolve(mockPayouts);
  //   }, 1000);
  // });
  return data;
};

export const getPayout = async (payoutId: string): Promise<Payout> => {
  const { data } = await service.get(`/${payoutId}`);
  // const data = new Promise<Payout>(resolve => {
  //   setTimeout(() => {
  //     resolve(mockPayouts[0]);
  //   }, 1000);
  // });
  return data;
};
